function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12.214L1.92 9.57a1.105 1.105 0 00-1.59 0c-.44.45-.44 1.18 0 1.632l3.375 3.461c.439.45 1.151.45 1.59 0L17.67 1.97c.44-.45.44-1.181 0-1.632a1.105 1.105 0 00-1.59 0L4.5 12.214z",
  id: "yes_svg__a"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("use", {
  fill: "#1CB279",
  xlinkHref: "#yes_svg__a"
});

var SvgYes = function SvgYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik00LjUgMTIuMjE0TDEuOTIgOS41N2ExLjEwNSAxLjEwNSAwIDAgMC0xLjU5IDBjLS40NC40NS0uNDQgMS4xOCAwIDEuNjMybDMuMzc1IDMuNDYxYy40MzkuNDUgMS4xNTEuNDUgMS41OSAwTDE3LjY3IDEuOTdjLjQ0LS40NS40NC0xLjE4MSAwLTEuNjMyYTEuMTA1IDEuMTA1IDAgMCAwLTEuNTkgMEw0LjUgMTIuMjE0eiIgaWQ9ImEiLz48L2RlZnM+PHVzZSBmaWxsPSIjMUNCMjc5IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIi8+PC9zdmc+";
export { SvgYes as ReactComponent };